import { render, staticRenderFns } from "./NewDistrict.vue?vue&type=template&id=5e900076&scoped=true"
import script from "./NewDistrict.vue?vue&type=script&lang=js"
export * from "./NewDistrict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e900076",
  null
  
)

export default component.exports